import { createSlice } from '@reduxjs/toolkit';

import initialState, * as handlers from './handlers';

const interviewTest = createSlice({
  name: 'interviewTest',
  initialState,
  reducers: {
    getInterviewTestRequest: handlers.getInterviewTestRequest,
    getInterviewTestSuccess: handlers.getInterviewTestSuccess,
    getInterviewTestFailure: handlers.getInterviewTestFailure,
  },
});

export const { actions } = interviewTest;

export const { getInterviewTestRequest, getInterviewTestSuccess, getInterviewTestFailure } = actions;

export default interviewTest.reducer;
